import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditGallery from "../../Components/Admin/AdminEditGallery";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditGalleryPage = () => {
  return (

    <AdminEditGallery />

  );
};

export default AdminEditGalleryPage;